import { takeLatest, put, select, take, call } from 'redux-saga/effects';
import { actions as appActions, LOGIN, HIDE_AUTH_MODAL } from 'shared/actions/app';
import { actions, START_ORDER_SUBMIT_FLOW } from 'actions';
import { isAuthenticated as isAuthenticatedSelector } from 'shared/selectors/app';
import { getBalance } from './balance';
import { getIdea, Idea } from './idea';

function* submitOrder({ payload: { ideaId } }: ReturnType<typeof actions.startOrderSubmitFlow>) {
  const { isAuthenticated }: ReturnType<typeof isAuthenticatedSelector> = yield select(
    isAuthenticatedSelector
  );

  if (!isAuthenticated) {
    yield put(
      appActions.showAuthModal('signin', `investments/${ideaId}`, 'desktopInvestmentRegistration')
    );
    const action:
      | ReturnType<typeof appActions.login>
      | ReturnType<typeof appActions.hideAuthModal> = yield take([LOGIN, HIDE_AUTH_MODAL]);
    if (action.type === HIDE_AUTH_MODAL) {
      return;
    }
  }

  const idea: Idea = yield call(getIdea, ideaId, 'cache-first');
  if (!idea) {
    return;
  }
  const balance: number = yield call(getBalance, idea.enterAmount.currency);

  if (balance < idea.enterAmount.value) {
    yield put(
      appActions.showDepositModal(
        {
          value: idea.enterAmount.value - balance,
          currency: idea.enterAmount.currency,
        },
        `/investments/idea/${idea.ideaType.toLowerCase()}/${idea.id}`
      )
    );
    return;
  }

  yield put(actions.showOrderSubmitModal(idea.id));
}

export default function* saga() {
  yield takeLatest(START_ORDER_SUBMIT_FLOW, submitOrder);
}
